import api from './api';

export const followService = {
  // Check if current user is following a specific user
  isFollowing: async (userId) => {
    try {
      const response = await api.get(`/follows/check/${userId}`);
      return response.data.following;
    } catch (error) {
      console.error('Failed to check follow status:', error);
      throw error.response?.data || { message: 'Failed to check follow status' };
    }
  },

  // Follow a user
  followUser: async (userId) => {
    try {
      const response = await api.post(`/follows/${userId}`);
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || '';
      // Already following — treat as success so callers update UI correctly
      if (message.toLowerCase().includes('already follows')) {
        return { alreadyFollowing: true };
      }
      console.error('Failed to follow user:', error);
      throw error.response?.data || { message: 'Failed to follow user' };
    }
  },

  // Unfollow a user
  unfollowUser: async (userId) => {
    try {
      await api.delete(`/follows/${userId}`);
      return true;
    } catch (error) {
      console.error('Failed to unfollow user:', error);
      throw error.response?.data || { message: 'Failed to unfollow user' };
    }
  },

  // Get followers of a user
  getFollowers: async (userId, page = 0, size = 20) => {
    try {
      const response = await api.get(`/follows/followers/${userId}`, {
        params: { page, size }
      });
      return response.data;
    } catch (error) {
      console.error('Failed to get followers:', error);
      throw error.response?.data || { message: 'Failed to get followers' };
    }
  },

  // Get users that a user is following
  getFollowing: async (userId, page = 0, size = 20) => {
    try {
      const response = await api.get(`/follows/following/${userId}`, {
        params: { page, size }
      });
      return response.data;
    } catch (error) {
      console.error('Failed to get following list:', error);
      throw error.response?.data || { message: 'Failed to get following list' };
    }
  }
};
